export default __webpack_public_path__ + "static/media/domino_counter_screen_5.c679a52f.png";